app.directive('amountSelect', [
    '$state', '$ionicHistory', '$ionicModal', '$timeout', 'LocaleService', 'UserService', 'constants', 'Storage',
    function ($state, $ionicHistory, $ionicModal, $timeout, LocaleService,UserService, Const, Storage) {
        return {
            scope: {
                amount: '=',
                config: '<',
                next: '&'
            },
            link: function (scope, element) {
                LocaleService.wait().then(function (translation) {
                    scope.translation = translation;
                });
                scope.paymentMethods = Storage.get('paymentMethods') || [];
                scope.user = UserService.get();
                scope.constants = Const;
                scope.changeStep = 50;

                scope.navigate = function (state, params) {
                    return $state.go(state, params);
                };

                scope.close = function () {
                    $ionicHistory && $ionicHistory.clearHistory();
                    scope.modal.hide();
                    scope.paymentMethods.length > 1 ? scope.navigate('root.app.wallet', {direction: 'right'}) : scope.navigate('root.app.assets', {direction: 'right'});
                };

                scope.continue = function (form) {
                    if (!form.$valid) return;
                    $ionicHistory && $ionicHistory.clearHistory();
                    scope.modal.hide();
                    return scope.next();
                };

                //create modal
                $ionicModal.fromTemplateUrl('templates/directives/amountSelect.html', {
                    scope: scope,
                    hardwareBackButtonClose: false,
                    animation: 'slide-in-up'
                }).then(function (modal) {
                    scope.modal = modal;
                    scope.modal.show();
                });

                element.on('$destroy', function () {
                    $ionicHistory && $ionicHistory.clearHistory();
                    scope.modal && scope.modal.remove && scope.modal.remove();
                    scope.modal = null;
                });
            }
        }
    }]);
